'use client'

import { useRef, useState } from 'react'

import axios from '@/utils/assessmentAxiosInterceptor'

import Icon from '@/components/Icon/Icon'
import Button from '@/components/Button/Button'
import Input from '@/components/Input/Input'

import styles from './Auth.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export default ({ setEmail, setError, setSelectedType }) => {
    const emailInput = useRef(null)

    const sendResetEmail = async () => {
        setError(null)
        grecaptcha.ready(() => {
            grecaptcha.execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, { action: 'submit' }).then(async (token) => {
                // Post the request to the server.
                try {
                    const { data } = await axios.post('/assessment/api/auth/forgottenPassword', {
                        email: emailInput.current.value,
                        captchaToken: token,
                    })

                    if (data.success) {
                        setEmail(emailInput.current.value)
                        return
                    }
                } catch (e) {
                    if (e?.response?.data) {
                        setError(e.response.data.message)
                    }
                }
            })
        })
    }
    return (
        <>
            <form
                className={classes('form')}
                onSubmit={(e) => e.preventDefault()}
                onKeyUp={({ key }) => key == 'Enter' && sendResetEmail()}
            >
                <h1 className={classes('title')}>Reset your password</h1>
                <p className={classes('subtext')}>No worries, we'll send you reset instructions.</p>
                <div className={classes('input-container')}>
                    <Input
                        type="email"
                        placeholder="Your email"
                        required={true}
                        ref={emailInput}
                        autoComplete="username"
                    />
                    <div className={classes('error-icon')}>
                        <Icon name="alert-circle" width={20} height={20} />
                    </div>
                </div>
            </form>
            <Button
                className={classes('login-button')}
                onClick={(e) => {
                    e.preventDefault()
                    sendResetEmail()
                }}
                text="Reset password"
            />
            <span className={classes('login-link')}>
                <a href="#" onClick={() => setSelectedType('login')}>
                    Back to login
                </a>
            </span>
        </>
    )
}
